export function userDetailsReducer(state = null, action) {
    if (action.type === 'SET_USER_DETAILS') return state = action.payload
    else return state;
}